export default class ListFilesLinks {
    constructor() {
        this.sections = document.querySelectorAll('.components-block-list-files-links');

        this.ready();
    }

    ready() {
        this.sections.forEach((section, index) => {
            section.setAttribute('id', 'anchor-section-' + index);
            if (section.querySelector('nav')) {
                const links = section.querySelectorAll('nav a');
                links.forEach((linkButton) => {
                    const hash = '#anchor-section-' + index;
                    const oldLink = linkButton.getAttribute('href');
                    const newLink = oldLink + hash;
                    linkButton.setAttribute('href', newLink);
                });
            }
        });
    }
}

if (document.querySelector('.components-block-list-files-links')) {
    new ListFilesLinks();
}
